import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oneshubh/satyam/SocialGraphs/src/components/HomePage.tsx");
